import { gql } from '@apollo/client';

export const UPDATE_BILLING_INFO_MUTATION = gql`
  mutation wUpdateSubsBilling(
    $subscriptionUid: String!
    $paymentUid: String!
    $nameCC: String!
    $address: Object!
  ) {
    wUpdateSubsBilling(
      subscriptionUid: $subscriptionUid
      paymentUid: $paymentUid
      nameCC: $nameCC
      address: $address
    )
  }
`;
